import React from 'react';
import { BiDownload } from 'react-icons/bi';
import ExtraMaterials from '../../../../../../../models/extraMaterials';
import { ExtraMaterialCardContainer, ExtraMaterialCardName } from './style';

interface ExtraMaterialCardProps {
  extraMaterial: ExtraMaterials;
}

const ExtraMaterialCard: React.FC<ExtraMaterialCardProps> = ({
  extraMaterial,
}) => {
  const downloadMaterial = () => {
    window.open(extraMaterial.reference, '_blank');
  };

  return (
    <ExtraMaterialCardContainer onClick={downloadMaterial}>
      <ExtraMaterialCardName>{extraMaterial.name}</ExtraMaterialCardName>
      <BiDownload size={18} />
    </ExtraMaterialCardContainer>
  );
};

export default ExtraMaterialCard;
